export default __webpack_public_path__ + "static/media/emojione_money-with-wings.01a76dde.svg";